import { alpha, Stack, styled } from '@mui/material';

import { getThemeColor, TMoplaColors } from '@mopla/mui';

interface IMplPaperProps {
	backgroundOpacity?: number;
	backgroundColor?: TMoplaColors;
}

export const MplPaper = styled(Stack, {
	shouldForwardProp: (prop) =>
		prop !== 'backgroundColor' && prop !== 'backgroundOpacity',
})<IMplPaperProps>(
	({ theme, backgroundOpacity = 1, backgroundColor = 'neutral.0' }) => ({
		padding: '24px 16px',
		boxSizing: 'border-box',
		borderRadius: 8,
		backgroundColor: alpha(
			getThemeColor(backgroundColor, theme),
			backgroundOpacity
		),
	})
);
